import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withState } from 'recompose'
import { updateSiteConfigs } from 'actions/Site'
import AutoDebitLogPayment from 'components/pages/autoDebit/logPayment'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth
  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('stateCheck', 'setStateCheck', {
    isLocked: false,
  }),
  lifecycle({
    async componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Autodebet - Log Payment',
        activePage: 'auto-debet/log-payment',
        activeSubPage: 'log-payment',
      })
    },
  }),
)(AutoDebitLogPayment)
